import { render, staticRenderFns } from "./TextAreaCustom.vue?vue&type=template&id=b42fab9c&scoped=true&"
import script from "./TextAreaCustom.vue?vue&type=script&lang=js&"
export * from "./TextAreaCustom.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaCustom.vue?vue&type=style&index=0&id=b42fab9c&scoped=true&lang=scss&"
import style1 from "./TextAreaCustom.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42fab9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
